"use client";

import { $api } from "@/lib/api-client";

interface DeleteElectionAttachmentReturn {
  deleteAsync: (url: string) => Promise<void>;
  isPending: boolean;
}

/**
 * Wraps DELETE /election/attachment?url=<url>.
 * Resolves void on 204. Rejects with an Error that has a `.status` field
 * so AttachmentUploader can distinguish 403 (orphan-swallow) from other failures.
 */
export function useDeleteElectionAttachment(): DeleteElectionAttachmentReturn {
  const mutation = $api.useMutation("delete", "/election/attachment");

  async function deleteAsync(url: string): Promise<void> {
    await mutation.mutateAsync({
      params: { query: { url } },
    });
  }

  return {
    deleteAsync,
    isPending: mutation.isPending,
  };
}
